<template>
  <div class="tableBtn">
    <b-button id="confirmBtn" pill size="sm" :disabled="disabled" @click="onClick"
      ><slot><i class="bi bi-check2 icon confirmBtnIcon"></i></slot
    ></b-button>
  </div>
</template>

<script>
export default {
  name: 'ConfirmButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick() {
      this.$emit('clickEvent')
    }
  }
}
</script>

<style lang="scss" scoped>
$icon-color: white;

.confirmBtnIcon {
  font-size: 16px;
  color: $icon-color;
}
</style>
